import React, { useState, useRef, useEffect,useLayoutEffect } from "react";
import "./Legalassistant.css";
import { logEvent } from "firebase/analytics";
import { config } from "../config";
import { useLocation, useNavigate } from "react-router-dom";
import FullScreenLoader from "../components/FullScreenLoader";
import { toast, ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet-async";
import GoogleButton from "../components/GoogleAuth";
import jsPDF from "jspdf";
import { Document, Packer, Paragraph, HeadingLevel } from "docx";
import { Snackbar } from "@mui/material";
import { Alert } from "@mui/material";
import { saveAs } from "file-saver";
import LeftPanel from "../components/leftPanel";
import { analytics } from "../components/firebase";
const Legalassistant = () => {
  const googleAuthRef = useRef(null);
  const [openMenuFor, setOpenMenuFor] = useState(null); 
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const chatEndRef = useRef(null);
  const textAreaRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const messagesContainerRef = useRef(null);
  const [historyId, setHistoryId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
    const [isSnackbarOpen, setSnackbarOpen] = useState(false);
    const [showLoginPopup, setShowLoginPopup] = useState(false);

      // Buffer for retry after login
  const [pendingMessage, setPendingMessage] = useState(null);
  const fileInputRef = useRef(null);
 
  const handleBackClick = () => {
    navigate(-1);
  };

   const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }; 


  useLayoutEffect(() => {
    if (messages.length > 0) {
      chatEndRef.current?.scrollIntoView({ behavior: 'auto' });
    }
  }, [messages]);     // re-run on every messages array change
  const handleClose = () => {
    setSnackbarOpen(false);
  };
  const showNotification = (msg, severity = "success") => {
    setMessage(msg);
    setSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    const id = location.state?.history_Id;
    if (id) {
      setHistoryId(id);
      fetchChatHistory(id);
    }
  }, [location.state]);

  const fetchChatHistory = async (id) => {
    try {
      const res = await fetch(
        `${config.baseURL}/chat_history.php?history_id=${id}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      const data = await res.json();

      if (data.success && Array.isArray(data.messages)) {
        // Assuming `data.messages` is an array like: [{ sender: 'user', text: '...' }, { sender: 'ai', text: '...' }]
        setMessages(data.messages);
      } else {
       
      }
    } catch (err) {
      
    }
  };
  
  
  useEffect(() => {
    if (messages.length > 0) {
      scrollToBottom();
    }
  }, [messages]);

  useEffect(() => {
    if (location.state?.text) {
      setInput(location.state.text);
    }
  }, [location.state]);

  useEffect(() => {
    if (input && location.state?.text) {
      handleSend();
      navigate(location.pathname, { replace: true });
    }
  }, [input]);

  const handleSend = async () => {
    if (!input.trim() || loading) return;

    const fileToSend = uploadedFile;
    setUploadedFile(null);

    const userMessage = {
      sender: "user",
      text: input,
      fileName: fileToSend?.name ?? null,
    };
    setMessages((prev) => [...prev, userMessage]);
    const payload = { message: input, file: fileToSend };
    const currentInput = input;
    setInput("");
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("message", currentInput);


      if (historyId) formData.append("history_id", historyId);
      if (uploadedFile) formData.append("pdf_file", uploadedFile);

      const res = await fetch(`${config.baseURL}/chat.php`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      const rawResponse = await res.text();
      let data;
      try {
        data = JSON.parse(rawResponse);
      } catch {
        throw new Error("Invalid JSON response");
      }

      if (
        data.error === "Authentication failed" ||
        data.error === "Authentication jwt not found failed"
      ) {
        setPendingMessage(payload);
        setShowLoginPopup(true);
        return;
      }

      if (!data.success) {
        if (data.redirect === "premium") {
          const limitMsg =
            "Your free limit is reached. Please upgrade to Pro. Redirecting to plans page...";
          setMessages((prev) => [...prev, { sender: "ai", text: limitMsg }]);

          setTimeout(() => {
            navigate("/premium");
          }, 4000);
          return;
        }
        throw new Error(data.error || "Chat error");
      }

      if (!historyId && data.history_id) {
        setHistoryId(data.history_id);
      }

      const fullText = data.reply;
      if (fullText?.length) {
        let currentText = "";
        let index = 0;
        setMessages((prev) => [...prev, { sender: "ai", text: "" }]);

        const typingInterval = setInterval(() => {
          if (index < fullText.length) {
            currentText += fullText.charAt(index++);
            setMessages((prev) => {
              const updated = [...prev];
              updated[updated.length - 1] = { sender: "ai", text: currentText };
              return updated;
            });
          
          } else {
            clearInterval(typingInterval);
          }
        }, 5);
      } else {
        setMessages((prev) => [
          ...prev,
          {
            sender: "ai",
            text: "Sorry, there was an issue generating the response.",
          },
        ]);
      }

      logEvent(analytics, "send_message", { message: currentInput });
    } catch (err) {
   
      console.error(err);
      setMessages((prev) => [
        ...prev,
        {
          sender: "ai",
          text: "Sorry, something went wrong. Please try again later.",
        },
      ]);
    } finally {
      
      setLoading(false);
    }
  };

  const doSend = async ({ message, file }) => {
    const form = new FormData();
    form.append('message', message);
    if (historyId) form.append('history_id', historyId);
    if (file)      form.append('pdf_file', file);

    const res = await fetch(`${config.baseURL}/chat.php`, {
      method: 'POST',
      credentials: 'include',
      body: form,
    });
    const raw = await res.text();
    const data = JSON.parse(raw);

    if (
      data.error === 'Authentication failed' ||
      data.error === 'Authentication jwt not found failed'
    ) {
      throw new Error('Authentication failed');
    }
    if (!data.success) {
      if (data.redirect === 'premium') {
        setMessages(m => [
          ...m,
          { sender: 'ai', text: 'Free limit reached. Redirecting to Pro…' }
        ]);
        setTimeout(() => navigate('/premium'), 3000);
        return;
      }
      throw new Error(data.error || 'Chat error');
    }
    if (!historyId && data.history_id) {
      setHistoryId(data.history_id);
    }

    // Typing animation
    const reply = data.reply || '…oops, empty reply.';
    setMessages(m => [...m, { sender: 'ai', text: '' }]);
    let idx = 0, textSoFar = '';
    const iv = setInterval(() => {
      if (idx < reply.length) {
        textSoFar += reply.charAt(idx++);
        setMessages(prev => {
          const copy = [...prev];
          copy[copy.length - 1].text = textSoFar;
          return copy;
        });
      } else {
        clearInterval(iv);
      }
    }, 10);
  };

 

  const handleLoginFailure = () => { navigate (-1)};

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSend();
  };
  

  const handleSavePdf = (text) => {
    const words = text
      .trim()
      .split(/\s+/)
      .slice(0, 3);
    const docTitle = words.length
      ? words.join("_")
      : "document";
  
    const pdf = new jsPDF();
    pdf.setFontSize(12);
    const lines = pdf.splitTextToSize(text, 180);
    pdf.text(lines, 10, 10);
    pdf.save(`${docTitle}.pdf`);
  
    showNotification("PDF saved successfully ✅");
    logEvent(analytics, "legal_docaction", {
      action: "save_as_pdf",
      button_name: "save_pdf",
      source: "history_preview",
    });
  };
  
  // DOCX
  const handleSaveDocx = async (text) => {
    const words = text
      .trim()
      .split(/\s+/)
      .slice(0, 3);
    const docTitle = words.length
      ? words.join("_")
      : "document";
  
    const allParagraphs = text
      .split("\n")
      .map((line) => new Paragraph(line));
    const doc = new Document({
      sections: [{ properties: {}, children: allParagraphs }],
    });
    const blob = await Packer.toBlob(doc);
    saveAs(blob, `${docTitle}.docx`);
  
    showNotification("DOCX saved successfully ✅");
    logEvent(analytics, "legal_docaction", {
      action: "save_as_docx",
      button_name: "save_docx",
      source: "history_preview",
    });
  };

  useEffect(() => {
  function onClick(e) {
    // if a menu is open but the click is outside any .chat-actions
    if (openMenuFor !== null && !e.target.closest('.chat-actions')) {
      setOpenMenuFor(null);
    }
  }
  window.addEventListener('mousedown', onClick);
  return () => window.removeEventListener('mousedown', onClick);
}, [openMenuFor]);




const handleLoginSuccess = async () => {
  setShowLoginPopup(false);
  if (!pendingMessage) return;

  setLoading(true);
  try {
    await doSend(pendingMessage);
  } catch (err) {
    console.error(err);
    setMessages(m => [
      ...m,
      { sender: 'ai', text: 'Failed to send after login. Please retry.' }
    ]);
  } finally {
    setPendingMessage(null);
    setLoading(false);
  }
};



  
  return (
    <>
      <Helmet key="landing">
        <title>
          AI Legal Assistant Chat | Get Help Understanding Legal Cases &
          Documents
        </title>

        <meta
          name="description"
          content="Talk to our AI Legal Assistant to get instant help understanding legal cases, contracts, and documents. Ask questions, get summaries, clarify legal terms, and generate legal drafts—all in real time using advanced AI."
        />

        <meta
          name="keywords"
          content="AI legal assistant, chat with legal AI, understand legal documents, legal case help, legal chatbot, AI legal support, explain legal terms, legal AI tool, legal document explanation, ask legal questions online, AI lawyer assistant, legal AI advisor, understand contracts, AI legal case analyzer, real-time legal advice, legal assistant bot"
        />

        <link
          rel="canonical"
          href="https://legaldocumentgenerator.com/ai-assistant"
        />
      </Helmet>      
      <div className="create_background">
        <LeftPanel />

        <div className="create_assistant">
          <div className="create_title_assistant">
            <img
              src={config.Backbutton}
              alt="back icon"
              onClick={handleBackClick}
            />
            Ai assistant
          </div>
          <div className="chat-container">
          <div className="chat-messages" ref={messagesContainerRef}>
          
  {messages.map((msg, i) => (
    <div key={i} className={`chat-row ${msg.sender}`}>
      {/* only show the avatar for AI messages */}
      {msg.sender === "ai" && (
        <img
          src={config.aiAvatar}
          alt="AI"
          className="ai-avatar"
        />
      )}

      {/* the chat bubble */}
      <div className={`chat-bubble ${msg.sender}`}>
        {msg.fileName && (
          <div className="chat-file-name">
            <img src={config.uploadedDoc} alt="Doc" /> {msg.fileName}
          </div>
        )}

        <div className="chat-text">{msg.text}</div>

        {msg.sender === "ai" && (
          <div className="chat-actions">
            <button
              className="action-btn"
              onClick={() => {
                navigator.clipboard.writeText(msg.text);
                setOpenMenuFor(null);
                showNotification("Text copied to clipboard ✅");
              }}
            >
              <img src={config.copyButton} alt="copy" />
            </button>
            <button
              className="action-btn"
              onClick={() => navigator.share?.({ text: msg.text })}
            >
              <img src={config.shareButton} alt="share" />
            </button>
            <button
              className="action-btn"
              onClick={() => handleSavePdf(msg.text)}
              title="Save as PDF"
            >
              <img src={config.pdfRed} alt="pdf" />
            </button>
            <div className="menu-wrapper_legalAssitant">
                          <button
                            className="menu-trigger_legalAssitant"
                            onClick={() =>
                              setOpenMenuFor(openMenuFor === i ? null : i)
                            }
                          >
                           <img src={config.menuRed} alt="menu" />
                          </button>

                          {openMenuFor === i && (
                            <div className="action-menu_legalAssitant">
                              <button
                                className="action-btn_legalAssitant"
                                onClick={() => {
                                  navigator.clipboard.writeText(msg.text);
                                  setOpenMenuFor(null);
                                  showNotification("Text copied to clipboard ✅");
                                }}
                              >
                                Copy Text
                              </button>
                              <button
                                className="action-btn_legalAssitant"
                                onClick={() => {
                                  navigator.share?.({ text: msg.text });
                                  setOpenMenuFor(null);
                                  
                                }}
                              >
                                Share Text
                              </button>
                              <button
                                className="action-btn_legalAssitant"
                                onClick={() => {
                                  handleSavePdf(msg.text);
                                  setOpenMenuFor(null);
                                }}
                              >
                                Save as PDF
                              </button>
                              <button
                                className="action-btn_legalAssitant"
                                onClick={() => {
                                  handleSaveDocx(msg.text);
                                  setOpenMenuFor(null);
                                }}
                              >
                                Save as Doc
                              </button>
                            </div>
                          )}
                        </div>                                   
  
          </div>
        )}
      </div>
    </div>
    
  ))}
 

  {loading && (
    <div className="chat-row ai">
      <img
        src={config.aiAvatar}
        alt="AI"
        className="ai-avatar"
      />
      <div className="chat-bubble ai typing">
              <div className="typing-dots">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
    </div>
  )}

  <div ref={chatEndRef} />
</div>

{showLoginPopup && (
        <div className="chat-login-popup-overlay">
          <div className="chat-login-popup">
            <h2>Please log in</h2>
            <div className="chat-login-popup-buttons" >
            <GoogleButton
            id="loginchatPopup"
              ref={googleAuthRef}
              onClick={() => googleAuthRef.current.login()}
              onLoginSuccess={() => {
                setShowLoginPopup(false);
                handleLoginSuccess();
              }}
              onLoginFailure={handleLoginFailure}
            />
            <button
               id="loginchatPopup"
              onClick={() => {
                setShowLoginPopup(false);
                navigate(-1);
              }}
            >Back</button>
          </div>
          </div>
        </div>
      )}
            
             <Snackbar
                      open={isSnackbarOpen}
                      autoHideDuration={2000}
                      onClose={handleClose}
                      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    >
                      <Alert severity={severity} sx={{ width: "100%", borderRadius: 2 }}>
                        {message}
                      </Alert>
                    </Snackbar>
          </div>

          <div className="chat-section">

           
              {uploadedFile && (
                <div className="uploaded-file-name"><img src={config.uploadedDoc} alt="Doc" /> {uploadedFile.name}</div>
              )}
              <input
                type="file"
                accept=".pdf,.docx"
                style={{ display: "none" }}
                id="fileUpload"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    if (file.size > 5 * 1024 * 1024) {
                      toast.error("File size must be less than 5 MB.");
                      return;
                    }
                    setUploadedFile(file);
                  }
                }}
              />

         
          <div className="chat-input-container">
                <textarea
                  type="text"
                  className="chat-input"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={handleKeyPress}
                  placeholder="Ask a legal question or upload a document for analysis.."
                />
                <label htmlFor="fileUpload" className="chat-Upload-button">
                  <img src={config.fileUpload} alt="upload"  className="chat-Upload-img"/>
                </label>
                <img
                  src={config.sendButton}
                  alt=""
                  className="chat-send-button"
                  onClick={handleSend}
                />
                
              </div>
              </div>
        </div>
      </div>
    </>
  );
};

export default Legalassistant;
